document.addEventListener('DOMContentLoaded', function() {
    const comparisonKey = 'Comparsion';
    const pageWrapper = document.querySelector('.compare-page')
    const comparisonContainer = document.querySelector('.compare-page__head');
    const list = document.querySelector('.compare-page__list')
    const productHandles = JSON.parse(localStorage.getItem(comparisonKey)) || [];
    const identical = document.getElementById('hide-identical')

    if (productHandles.length === 0) {
        comparisonContainer.innerHTML = '<p>No products in comparison.</p>';
        return;
    }
    render().then(()=> rebuild()).then(()=>loading());
    
    function rebuild(){
        const compareList = document.querySelector('.compare-page__list');
        const titles = Array.from(compareList.querySelectorAll('.compare-page__list-title .compare-page__list-item'));
        const products = Array.from(compareList.querySelectorAll('.compare-page__list-product'));

        // Create a new container for the transformed list
        const newCompareList = document.createElement('div');
        newCompareList.classList.add('compare-page__list');

        // Iterate through the titles and corresponding product details
        titles.forEach((title, index) => {
            const line = document.createElement('div');
            line.classList.add('compare-page__list-line');

            // Add the title to the line
            const titleDiv = document.createElement('div');
            titleDiv.classList.add('compare-page__list-title');
            titleDiv.innerHTML = title.innerHTML;
            line.appendChild(titleDiv);

            // Add corresponding product details to the line
            products.forEach(product => {

                const productDiv = document.createElement('div');
                productDiv.classList.add('compare-page__list-product');
                productDiv.innerHTML = product.children[index].innerHTML
                line.appendChild(productDiv);
            });

            newCompareList.appendChild(line);
            
        });

        // Replace the old list with the new transformed list
        compareList.parentNode.replaceChild(newCompareList, compareList);


        const len = newCompareList.querySelectorAll('.compare-page__list-line').length
        const lastLine = newCompareList.querySelectorAll('.compare-page__list-line')[len-1];
        lastLine.classList.add('compare-page__list-line--last')
        lastLine.querySelectorAll('.compare-page__list-product').forEach((item, index) =>{
            item.appendChild(document.querySelectorAll('.comparsion__product')[index].cloneNode(true))
            
        })
    }

    async function render (){
        for (const productId of productHandles) {
            try {
                const response = await fetch(`/products/${productId}`);
                if (!response.ok) {
                    throw new Error(`Failed to fetch product information for ID: ${productId}`);
                }
                const text = await response.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(text, 'text/html');
                const productTemplate = doc.querySelector('#comparsion-content-template');
                const comparsionTemplate = doc.querySelector('#comparsion-fields-template');
                if (comparsionTemplate) {
                    const ItemDiv = document.createElement('div');
                    ItemDiv.classList.add('compare-page__list-product');
                    ItemDiv.innerHTML = comparsionTemplate.innerHTML;
                    list.appendChild(ItemDiv);
                } else {
                    console.error(`Product content not found for product ID: ${productId}`);
                }
                if (productTemplate) {
                    const productDiv = document.createElement('div');
                    productDiv.classList.add('compare-page__head-product');
                    productDiv.innerHTML = productTemplate.innerHTML;
                    comparisonContainer.appendChild(productDiv);
                } else {
                    console.error(`Product content not found for product ID: ${productId}`);
                }
            } catch (error) {
                console.error('Error fetching product information:', error);
            }
        }
    }

    function loading(){
        pageWrapper.classList.add('compare-page--loaded')
    }

    identical.addEventListener('change', (e)=>{
        const lines = document.querySelectorAll('.compare-page__list-line');
        if (e.target.checked){
            lines.forEach(line => {
                const productValues = line.querySelectorAll('.compare-page__list-product');
                let v = '';
                productValues.forEach(value=>{
                    if (value.innerHTML == v) {
                        line.classList.add('compare-page__list-line--hidden')
                    } else {
                        v = value.innerHTML
                    }
                })
            })
        } else {
            lines.forEach(line =>  line.classList.remove('compare-page__list-line--hidden'));
        }
       
    })
});